module.exports = __webpack_public_path__ + "img/SKMJ_heavy6.d5a77a90.png";